import React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { OUTLINED_STATUSES } from '../constants/paymentLinks.constants';
import {
  getStatusConfig,
  getStatusDescription,
} from '../utils/paymentLinks.utils';

export const StatusChip = ({
  compact = false,
  status,
}: {
  compact?: boolean;
  status: string;
}) => {
  const config = getStatusConfig(status);
  const compactColor =
    config.color === 'default'
      ? {
          bgcolor: 'action.hover',
          color: 'text.secondary',
        }
      : {
          bgcolor: `${config.color}.light3`,
          color: `${config.color}.main`,
        };

  return (
    <Tooltip title={`${config.label}: ${getStatusDescription(status)}`} arrow>
      <Chip
        label={config.label}
        color={config.color as any}
        size="small"
        variant={OUTLINED_STATUSES.includes(status) ? 'outlined' : 'filled'}
        sx={{
          ...(compact ? compactColor : {}),
          border: compact ? 0 : undefined,
          height: compact ? 20 : undefined,
          maxWidth: compact ? 126 : { xs: 136, sm: 168 },
          '& .MuiChip-label': {
            display: 'block',
            fontSize: compact ? 10 : undefined,
            fontWeight: compact ? 700 : undefined,
            px: compact ? 0.65 : undefined,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        }}
      />
    </Tooltip>
  );
};

export default StatusChip;
